<template>
  <v-dialog
    retain-focus
    :value="create"
    v-on:click:outside="$router.push('/user')"
    max-width="600px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <v-card>
      <v-card-title tabindex="-1">
        <span class="headline">Create User</span>
        <v-btn
          style="position: absolute; top: 0; right: 0;"
          @click="
            () => {
              this['User/fetchUsers']({ page: this.page });
              $router.push('/user');
            }
          "
          color="error"
          dark
          icon
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-form width="100%" ref="createForm" v-model="createValid">
          <v-text-field
            label="Name*"
            v-model="createFields.name"
            :rules="validationRules.name"
            :error-messages="inputErrorMessages('name')"
            v-on:keyup.enter="saveUser"
            name="name"
            index="1"
          ></v-text-field>
          <v-text-field
            label="Email Address*"
            v-model="createFields.email"
            :rules="validationRules.email"
            :error-messages="inputErrorMessages('email')"
            name="email"
          ></v-text-field>
          <v-text-field
            label="Password*"
            v-model="createFields.password"
            :type="'password'"
            :rules="validationRules.password"
            :error-messages="inputErrorMessages('password')"
            name="password"
          ></v-text-field>
          <v-text-field
            label="Confirm Password"
            v-model="createFields.confirmpassword"
            :type="'password'"
            :rules="[
              createFields.password === createFields.confirmpassword || 'Password must match'
            ]"
            :error-messages="inputErrorMessages('confirmpassword')"
            name="confirmpassword"
          ></v-text-field>
        </v-form>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="blue darken-1"
          text
          @click="
            $router.push('/user');
            clearCreate();
            $refs.createForm.resetValidation();
          "
          >Cancel</v-btn
        >
        <v-btn color="blue darken-1" text @click="saveUser">Save</v-btn>
        <v-switch v-model="continousCreation" label="Continuous Create"></v-switch>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { mapActions } from 'vuex';

export default {
  data: function() {
    return {
      continousCreation: false,
      createValid: true,
      validationRules: {
        name: [
          v => !!v || this.rem('Name'),
          v => !v || v.length <= 255 || 'Name should not be greater than 255'
        ],
        email: [
          v => !!v || this.rem('Email address'),
          v => !v || /.+@.+/.test(v) || 'Email address must be valid'
        ],
        password: [
          v => !!v || this.rem('Password'),
          v => !v || v.length <= 10 || 'Password should not be greater than 10',
          v => !v || v.length >= 5 || 'Password should not be less than 5'
        ]
      },
      errorMessages: {},
      createFields: {
        name: '',
        email: '',
        password: '',
        confirmpassword: ''
      }
    };
  },
  props: {
    create: false,
    page: 0
  },
  methods: {
    ...mapActions(['User/fetchUsers']),
    clearCreate() {
      this.createFields = {
        name: '',
        email: '',
        password: '',
        confirmpassword: ''
      };
    },
    rem(name) {
      return `${name} is required`;
    },
    inputErrorMessages(input) {
      return this.errorMessages[input];
    },
    saveUser() {
      if (this.$refs.createForm.validate()) {
        axios
          .post('api/v1/user', this.createFields)
          .then(response => {
            this.$store.commit('SET_SNACK_BAR', {
              message: 'User created successfully...',
              color: 'success'
            });
            this.errorMessages = [];
            this.clearCreate();
            this.$refs.createForm.resetValidation();
            this['User/fetchUsers']({ page: this.page });
            if (this.continousCreation === false) {
              this.$router.push('/user');
            }
          })
          .catch(error => {
            if (error.response.status == 403) {
              this.$store.commit('SET_SNACK_BAR', {
                message: error.response.data['message'],
                color: 'error'
              });
            } else {
              this.errorMessages = error.response.data.errors;
            }
          })
          .finally(() => {});
      }
    }
  }
};
</script>